import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'table-configuration-ocr',
    templateUrl: './configuration-ocr.component.html',
    styleUrls: ['./configuration-ocr.component.scss'],
})
export class TableConfigurationOCRComponent implements OnInit {

    @Input('data') config;

    constructor() { }

    ngOnInit() { }
    // Método para obter o nome descritivo do tipo de OCR
    getOCRTypeName(typeId: string): string {
        switch (typeId) {
            case '1':
                return 'Identificadores de Fatura';
            case '2':
                return 'Lista Negra';
            default:
                return 'Tipo de OCR Desconhecido';
        }
    }
}
